import { Route } from "@angular/router";
import { SolicitarAntecipacaoPage } from "./solicitar-antecipacao.page";

export const SolicitarAntecipacaoRouter: Route[] = [
  { path: 'solicitar-antecipacao', component: SolicitarAntecipacaoPage }
];
